import { fbt } from 'fbtee'
import { Search, X } from 'lucide-react'
import { clearSearchLabel } from '../../../lib/commonStrings'
import { Input } from '../../../components/ui/input'

// Search input for the lineup. Unlike the schedule's dropdown, results render
// as a full grid surface below (owned by LineupView), so this is just the box —
// no keyboard list nav, just Esc to clear.
export function LineupSearch({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 size-3.5 text-muted-foreground pointer-events-none" />
      <Input
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Escape') onChange('')
        }}
        placeholder={fbt('Search the lineup', 'Placeholder for the lineup search box')}
        className="pl-8 pr-8"
        aria-label={fbt('Search the lineup', 'Accessible label for the lineup search box')}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={clearSearchLabel()}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground cursor-pointer"
        >
          <X className="size-3.5" />
        </button>
      )}
    </div>
  )
}
